import { Client } from "../types/UserTypes";

export const clientProfileProgressPercent = (client: Client) => {
    const fkComplete = Object.keys(client?.neatt?.fk || {})?.length === 7;
    const fkStarted = Object.keys(client?.neatt?.fk || {})?.length > 0;

    const eiCompleted = Object.keys(client?.neatt?.ei || {})?.length === 6;
    const eiStarted = Object.keys(client?.neatt?.ei || {})?.length > 0;

    const ltCompleted = Object.keys(client?.neatt?.lt || {})?.length === 4;
    const ltStarted = Object.keys(client?.neatt?.lt || {})?.length > 0;

    const fhCompleted = Object.keys(client?.neatt?.fh || {})?.length >= 7;
    const fhStarted = Object.keys(client?.neatt?.fh || {})?.length > 0;

    const fgCompleted = Object.keys(client?.neatt?.fg || {})?.length === 12;
    const fgStarted = Object.keys(client?.neatt?.fg || {})?.length > 0;

    const result: Record<any, any> = {
        financialKnowledge: {
            completed: fkComplete,
            started: fkStarted,
        },
        employmentInfo: {
            completed: eiCompleted,
            started: eiStarted,
        },
        loanType: {
            completed: ltCompleted,
            started: ltStarted,
        },
        financialHistory: {
            completed: fhCompleted,
            started: fhStarted,
        },
        financialGoals: {
            completed: fgCompleted,
            started: fgStarted,
        },
    };

    const keys = Object.keys(result);
    let numberOfCompletedForms = 0;

    if (keys.length) {
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
    
            //@ts-ignore
            if (result[key]?.completed) numberOfCompletedForms++;
        }
    
        result.percentCompleted = (numberOfCompletedForms / keys.length) * 100;
    }

    result.allCompleted = Boolean(fkComplete && eiCompleted && ltCompleted && fhCompleted && fgCompleted);

    return result;
}